interface SkeletonProps {
  className?: string;
  lines?: number;
}

export function SkeletonLoader({ className = '', lines = 3 }: SkeletonProps) {
  return (
    <div className={`space-y-3 ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className="h-4 bg-[#E8E8E8] rounded animate-pulse"
          style={{ width: `${80 - i * 15}%` }}
        />
      ))}
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div className="bg-white border border-[#DDDDDD] rounded-2xl p-5 space-y-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-[#E8E8E8] rounded-full animate-pulse" />
        <div className="space-y-2 flex-1">
          <div className="h-4 bg-[#E8E8E8] rounded animate-pulse w-1/3" />
          <div className="h-3 bg-[#E8E8E8] rounded animate-pulse w-1/2" />
        </div>
      </div>
      <SkeletonLoader lines={3} />
    </div>
  );
}
